import styled, { css } from 'styled-components'
import { globalStyles } from '../../ottGlobalStyles'
import { device } from '../../../styles/GlobalVariables'

interface StyledProgramItemProps {
  programWidth: number
  showItemTitle?: boolean
}

export const RailFullPosterWrap = styled.div`
  display: flex;
  row-gap: 5.6vw;
  width: 100%;
  flex-direction: column;
  margin-bottom: 30px;
`
export const RailItemProgramPlaceHolder = styled.div``
export const RailFullPosterRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    ${(size => {
      return css`
        width: calc(100vw / ${size});
        height: calc(100vw / ${size} * 1.78);
      `
    })(8.4)}

    img {
      height: 100%;
    }
  }

  @media only screen and (max-width: 768px) {
    justify-content: space-between;
    row-gap: 1rem;
    column-gap: 3%;
    > div {
      ${(size => {
        return css`
          width: calc(100vw / ${size});
          height: calc(100vw / ${size} * 1.78);
        `
      })(3.7)}
    }
  }
`
export const SeparateRailWrap = styled.div<StyledProgramItemProps>`
  position: relative;
  max-width: 100%;
  overflow: hidden;
  z-index: 3;
  transition: opacity 200ms ease-in;

  a {
    text-decoration: none;
  }

  ${device.small} {
    padding-left: ${globalStyles.gridPadding.desktop};
    padding-right: ${globalStyles.gridPadding.desktop};
    margin-bottom: 60px;

    .swiper {
      max-width: ${({ programWidth }) =>
        programWidth}vw; // Dynamic width based on prop
      overflow: visible !important;
      box-sizing: border-box;
      margin-bottom: 60px;
    }
  }

  @media only screen and (max-width: 768px) {
    margin-bottom: 48px;
    padding-left: ${globalStyles.gridPadding.mobile};
    padding-right: ${globalStyles.gridPadding.mobile};
    //padding-bottom: ${({ showItemTitle }) => (showItemTitle ? '0' : '16vw')};
    overflow: hidden;
    max-width: 100%;

    .swiper-slide {
      opacity: 1;
    }
  }

  .swiper {
    overflow: visible;
    opacity: 0;
    transition: opacity 1s ease;

    &.swiper-initialized {
      opacity: 1;
    }

    .swiper-slide {
      opacity: 0.4;
      transition: opacity 1s ease;

      &.swiper-slide-visible {
        opacity: 1;
      }
    }
  }

  ${props =>
    props.theme.isFirst &&
    css`
      margin-top: 20px;

      ${device.small} {
        margin-top: 40px;
      }
    `}
`
export const SeparateRailShowWrap = styled.div<StyledProgramItemProps>`
  position: relative;
  padding-top: 2.2%;
  padding-bottom: 5%;
  overflow: hidden;

  @media only screen and (min-width: 768px) {
    padding-left: ${globalStyles.gridPadding.desktop};
    padding-right: ${globalStyles.gridPadding.desktop};

    .swiper {
      max-width: ${({ programWidth }) =>
        programWidth}vw; // Dynamic width based on prop
      overflow: visible !important;
      box-sizing: border-box;
      margin-bottom: 1rem;

      &.swiper-container {
        // Additional styles for the container if needed
        .swiper-wrapper {
          // Additional styles for the wrapper if needed
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    padding-left: ${globalStyles.gridPadding.mobile};
    padding-right: ${globalStyles.gridPadding.mobile};
    ${({ showItemTitle }) =>
      showItemTitle
        ? css`
            margin-bottom: 17.2%;
          `
        : ''}
    padding-bottom: 15%;
  }
`
